import { createAsyncThunk } from '@reduxjs/toolkit';
import authApi from '~/apis/auth';
import {
  DELETE_PROFILE,
  UPDATE_PROFILE,
  FORGOT_PASSWORD,
  GET_PROFILE,
  LOGIN,
  RESET_PASSWORD,
  UPDATE_SETTING,
  DELETE_ACCOUNT,
} from '~/utils/constants/actionType';
import { ILoginPayload, IUpdateProfile, IUpdateSetting } from '~/utils/interface/auth';

import { IForgotPassword, IResetPassword, IResponseLogin } from '~/utils/interface/auth';
import { IProfile } from '~/utils/interface/auth';

export const handleLogin = createAsyncThunk<IResponseLogin, ILoginPayload>(
  LOGIN,
  async (data: ILoginPayload, { rejectWithValue }) => {
    try {
      const res = await authApi.login(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetProfile = createAsyncThunk<IProfile>(GET_PROFILE, async (_data, { rejectWithValue }) => {
  try {
    const res = await authApi.getProfile();
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleEditProfile = createAsyncThunk<string, { params: IUpdateProfile }>(
  UPDATE_PROFILE,
  async ({ params }, { rejectWithValue }) => {
    try {
      const res = await authApi.updateProfile(params);
      return res.data.message;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleEditSetting = createAsyncThunk<string, { params: IUpdateSetting }>(
  UPDATE_SETTING,
  async ({ params }, { rejectWithValue }) => {
    try {
      const res = await authApi.updateSetting(params);
      return res.data.message;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleForgotPassword = createAsyncThunk<string, { params: IForgotPassword }>(
  FORGOT_PASSWORD,
  async ({ params }, { rejectWithValue }) => {
    try {
      const res = await authApi.forgotPassword(params);
      return res.data.message;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleDeleteProfile = createAsyncThunk<string, void, { rejectValue: string }>(
  DELETE_PROFILE,
  async (_, { rejectWithValue }) => {
    try {
      const res = await authApi.deleteProfile();
      return res.data.message;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
export const handleResetPassword = createAsyncThunk<string, { params: IResetPassword }>(
  RESET_PASSWORD,
  async ({ params }, { rejectWithValue }) => {
    try {
      const res = await authApi.resetPassword(params);
      return res.data.message;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleDeleteAccount = createAsyncThunk<IResponseLogin, ILoginPayload>(
  DELETE_ACCOUNT,
  async (data: ILoginPayload, { rejectWithValue }) => {
    try {
      const res = await authApi.deleteAccount(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
